import _ from "lodash";
import {
  Component,
} from "react";
import {
  withLocation,
} from "CommonCore/router-util";
import {
  Button, Modal, Alert,
} from "react-bootstrap";
import {
  Spinner,
} from "CommonComponents/bricks";
import store from "CommonState/store";
import antragApi from "Apis/antrag-api";
import {
  injectsFromSchema,
  createInjectsSelector,
} from "CommonCore/schema-util";
import SHKFormTab, {
  setupAntragPanels,
} from "App/shk-form-tab";
import {
  DetailEditor,
} from "CommonComponents/detail-view";
import {
  subpanels as subpanels_stamm,
} from "App/person-stamm-tab";
import {
  istTypWerkvertrag,
  ROLLEN,
  userSachb,
} from "App/constants";
import SVASuchePopup from "Components/sva-suche-popup";
import apifetch from "CommonCore/apifetch";

const panels = _.cloneDeep([...subpanels_stamm]);
// Für Sachb nach dem Clone alle Hilfstexte herausfiltern
_.map(panels, p => p.schema.table = p.schema.table.filter(f => f.type != "plaintext"));

/*
 * Hintergrund: Am Antrag gibt es keine separaten Endpunkte je Untertabelle sondern nur einen, der die jeweiligen Arrays
 *              als künstliche Properties mit dem Namen der Tabelle dem Antragsdatensatz hinzufügt. Das folgende Mapping
 *              definiert, welche Endpunkte auf welche Property am Antrag projiziert werden und wie sich dabei die Feldnamen
 *              vom Prefix her ändern:
 */
const mapping = [{ endpoint: "/api/shkperson/person", prop: "antrag_person", pfrom: "p_", pto: "ap_" }];
setupAntragPanels(panels, mapping);

// Historie Personendaten präparieren
_.map(_.filter(panels, p => ["stamm"].indexOf(p.key) >= 0), panel => {
  panel.transformData = function(data) {
    /*
     * Eventuell vorhandene Historie dem obersten Element zuordnen
     * Dabei herausfinden, wo echte Änderungen vorhanden sind und nur diese Felder schicken
     */
    if (data && data.length > 1) {
      const history = [];
      const aktuell = _.omit(data[0], ["ap_crdate", "ap_weiterebv_jn"]);
      _.map(data.filter((f, idx) => idx > 0), record => {
        // Records ab Index 1 sind historische Daten, Inhalte vergleichen:
        const changes = {};
        const recorddate = record.ap_crdate;
        record = _.omit(record, ["ap_crdate", "ap_weiterebv_jn"]);
        _.map(Object.keys(record), key => {
          if (!_.isEqual(aktuell[key], record[key])) {
            // Record enthält Änderung zu aktuellem Stand
            changes[key] = record[key];
          }
        });
        if (!_.isEmpty(changes)) {
          changes._currdate = data[0].ap_crdate;
          changes._histdate = recorddate;
          history.push(changes);
        }
      });
      if (!_.isEmpty(history)) {
        data[0].history = history;
      }
    }
  };
});

const injects = _.flatMap(panels, s => injectsFromSchema(s.schema));
const selectInjects = createInjectsSelector(injects);

@withLocation
@store(...injects, "user")
@antragApi.actions
@antragApi.current
export default class AntragStammTab extends Component {
  constructor() {
    super();
    this.state = {};
  }

  updated() {
    this.setState({ needReload: false });
  }

  render() {
    const { currentAntrag, user } = this.props;
    const { popupSuche, popupSVALBVNummer } = this.state;

    // Rendermethods hinzufügen

    const stamm = _.find(panels, p => p.key == "stamm");
    if (userSachb(user)) {
      stamm.renderMethods = {
        ap_svakey: value => {
          return <span>{value}{value && "\u00a0"} <Button variant='outline-primary' onClick={this.startSuche}>Personalnummer {value ? "ändern" : "zuordnen"}</Button></span>;
        },
        ap_sva_lbvnr: value => {
          return <span>{value}{value && "\u00a0"} <Button variant='outline-primary' onClick={this.showSVALBVNummerPopup}>LBV-Personalnummer ändern/ergänzen</Button></span>;
        },

      };
    }

    if (!currentAntrag) {
      return <Spinner />;
    }


    const werkvertrag = istTypWerkvertrag(currentAntrag.a_katid);
    let mypanels = _.cloneDeep(panels);
    if (werkvertrag) {
      // Werkvertrag-Panels erlauben
      mypanels = mypanels.filter(x => ["stamm", "buwbv", "adresse", "bank", "werkvertrag"].indexOf(x.key) >= 0);
    }
    if (!werkvertrag) {
      // Alles außer buwbv+werkvertrag erlauben
      mypanels = mypanels.filter(x => ["buwbv", "werkvertrag"].indexOf(x.key) < 0);
    }
    // Rollen, die keine Kontaktdaten und Bankverbindung sehen dürfen
    const rollenOhneKontaktdaten = [
      ROLLEN.ROLLE_PERSONALRAT,
      ROLLEN.ROLLE_PERSONALRAT_TUV,
      ROLLEN.ROLLE_GLEICHSTELLUNG,
      ROLLEN.ROLLE_SBV,
    ];
    if (user && rollenOhneKontaktdaten.includes(user.ro_id)) {
      // Kontaktdaten und Bankverbindung nicht anzeigen
      mypanels = mypanels.filter(x => ["adresse", "bank"].indexOf(x.key) < 0);
    }

    return <div className='detail-form'>
      {popupSuche && <SVASuchePopup
        onOk={this.afterPersonalnummer}
        onCancel={() => {
          this.setState({ popupSuche: false });
        }}
        antrag={currentAntrag} />}

      {popupSVALBVNummer && <SVAPersonalnummerPopup
        onOk={this.afterPersonalnummer}
        onCancel={() => {
          this.setState({ popupSVALBVNummer: false });
        }}
        antrag={currentAntrag} />}

      <SHKFormTab
        key={this.state.renderKey} // Wenn die LBV-Personalnummer / Personalnummer geändert wurden. Neu rendern auslösen.
        readonly args={{ a_id: currentAntrag.a_id }}
        needReload={this.state.needReload}
        subpanels={mypanels}
        injects={selectInjects(this.props)} />
    </div>;
  }

  startSuche = () => {
    this.setState({ popupSuche: true });
  };

  showSVALBVNummerPopup = () => {
    this.setState({ popupSVALBVNummer: true });
  };

  afterPersonalnummer = async() => {
    // Suche durchgeführt und Personalnummer ggf. gesetzt
    const { currentAntrag } = this.props;
    await this.props.refreshAntragInStore(currentAntrag.a_id);
    this.setState({
      popupSuche: false,
      popupSVALBVNummer: false,
      needReload: true,
      renderKey: Date.now(), // Neuen renderKey für Force-Update
    });
  };
}

export class SVAPersonalnummerPopup extends Component {
  constructor() {
    super();
    this.state = { edits: {} };
  }

  componentDidMount() {
    const { antrag } = this.props;
    this.setState({ edits: { ap_sva_lbvnr: antrag.antrag_person[0].ap_sva_lbvnr } });
  }

  render() {
    const { onCancel } = this.props;
    const { errorMessage } = this.state;

    const mySchema = {
      table: [
        {
          field: "ap_sva_lbvnr",
          display: "LBV-Personalnummer",
          maxlength: 20,
        },
      ],
    };

    return (

      <Modal show onHide={onCancel}>
        <Modal.Header>
          <h2>LBV-Personalnummer ändern</h2>
        </Modal.Header>
        <Modal.Body>
          <p>Bitte ändern Sie die Personalnummer nach Bedarf :</p>
          <DetailEditor
            editable
            defaultEditable
            action='Speichern'
            schema={mySchema}
            entity={this.state.edits}
            onChange={this.onChange}
          />
          {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={this.onSave}>Speichern</Button>
          <Button variant='outline-primary' onClick={onCancel}>Abbrechen</Button>
        </Modal.Footer>
      </Modal>

    );
  }

  onChange = change => {
    const { edits } = this.state;
    _.assign(edits, change);
    this.setState({ edits });
  };
  onSave = async() => {
    const { antrag } = this.props;
    try {
      this.setState({ inflight: true, done: false });
      await apifetch("/api/shkantrag/antrag/personalnummer", {
        method: "POST",
        body: { a_id: antrag.a_id, ap_svakey: antrag.antrag_person[0].ap_svakey, ap_sva_lbvnr: this.state.edits.ap_sva_lbvnr },
      });
      this.props.onOk();
      this.setState({ inflight: false, done: true });
    } catch(err) {
      this.setState({
        inflight: false,
        errorMessage:
          "Setzen der SVA LBV Nummer:" + (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
      return false;
    }
  };
}

